"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_2 = require("@nextui-org/react");
var connected_channels_box_1 = __importDefault(require("./components/connected_channels_component/connected_channels_box"));
var PimConnectedChannelsComponent = function (props) {
    var values = props.values, updateValues = props.updateValues;
    var channels = values.channels;
    var _a = react_1.default.useState(null), localChannels = _a[0], setLocalChannels = _a[1];
    (0, react_1.useEffect)(function () {
        if (localChannels || (channels && channels.length > 0)) {
            var _channels = channels.reduce(function (acc, curr) {
                var _a;
                var _b;
                ((_a = acc[_b = curr.channel]) !== null && _a !== void 0 ? _a : (acc[_b] = [])).push(curr);
                return acc;
            }, {});
            setLocalChannels(_channels);
        }
    }, [channels]);
    return ((0, jsx_runtime_1.jsxs)(react_2.Card, __assign({ className: "w-full" }, { children: [(0, jsx_runtime_1.jsx)(react_2.CardHeader, __assign({ className: "flex justify-between items-center px-6 py-4" }, { children: (0, jsx_runtime_1.jsx)("h3", __assign({ className: "text-lg font-semibold" }, { children: "Connected Channels" })) })), (0, jsx_runtime_1.jsx)(react_2.Divider, {}), (0, jsx_runtime_1.jsx)(react_2.CardBody, { children: (0, jsx_runtime_1.jsx)(connected_channels_box_1.default, { channels: channels, updateValues: updateValues }) })] })));
};
exports.default = PimConnectedChannelsComponent;
